import { ServiceLocalize } from '../base';

class ServiceLocalizeMock extends ServiceLocalize {
  async getLang() {
    return {};
  }
}

export default ServiceLocalizeMock;
